module.exports = __webpack_public_path__ + "static/media/pb-4.0ec7817f.png";